import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01c7c64e&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports